/* eslint-disable no-nested-ternary */
import React, { useMemo, useEffect } from 'react';
import moment from 'moment';
import { projectStateType } from 'types';
import { Line, colors } from 'globalStyle';
import { Box, Grid } from '@material-ui/core';
import useCountdown from 'hooks/useCountdown';
import { Text, Title } from 'components/Texts';
import { NetworksShare } from 'components/Networks';
import ClockIcon from 'assets/icons/clock-gray.svg';
import PersonIcon from 'assets/icons/person-floor.svg';
import ClockIconGreen from 'assets/icons/clock-green.svg';
import CalendarIcon from 'assets/icons/calendar-gray.svg';
import CalendarIconGreen from 'assets/icons/calendar-green.svg';
import PersonIconGreen from 'assets/icons/person-floor-green.svg';

const toLocalDate = (date) => moment(date).format('D [de] MMMM YYYY');

export default function ProjectDescription({ isDesktop, singleProject, isSmall }) {
  const {
    time,
    setSettings,
    formattedTime,
    cancelTimer,
  } = useCountdown();
  const lessThanOneDay = useMemo(() => {
    const deltaTime = ((new Date(singleProject.campaignDate) - new Date()) / 1000);
    return deltaTime <= 86400 && deltaTime >= 0;
  }, [singleProject]);
  useEffect(() => {
    if (singleProject
        && singleProject?.status === projectStateType.ADVERTISING_CAMPAIGN
        && lessThanOneDay) {
      setSettings({
        format: 'HH:mm:ss',
        time: parseInt(((new Date(singleProject.campaignDate) - new Date())), 10),
      });
    }
  }, [singleProject]);
  useEffect(() => {
    if (time < 0) {
      cancelTimer();
    }
  }, [time]);
  return (
    <Grid
      container
      style={{
        paddingRight: !isDesktop && '37px',
        paddingTop: isDesktop ? '100px' : '14px',
        paddingLeft: isDesktop ? '100px' : '37px',
        paddingBottom: isDesktop ? '40px' : '20px',
        background: isDesktop && colors.background.GRAY_3,
      }}
    >
      <Grid item container xs={isDesktop ? 6 : 12}>
        <Box
          borderRight={isDesktop && `4px solid ${colors.primary}`}
        >
          <Title size={isDesktop ? 24 : 14}>
            Descripción del proyecto
          </Title>
          <Text mt={isDesktop ? 15 : 8} pb={isDesktop ? 30 : 3} size={!isDesktop && 13} width="95%">
            {singleProject?.shortDescription}
          </Text>
          <Title size={isDesktop ? 24 : 14} mt={!isDesktop && 10}>
            Derechos de los Valores
          </Title>
          <Text mt={isDesktop ? 15 : 8} pb={isDesktop ? 30 : 3} size={!isDesktop && 13} width="95%">
            <ul style={{ 'list-style': 'disc', 'padding-inline-start': '22px' }}>
              <li>
                Se tendrán hasta la extinción del pago de capital.
              </li>
              <li>
                Pueden ser transferidos.
              </li>
              <li>
                Pueden ser embargados.
              </li>
              <li>
                Pueden tener pago anticipado por parte del receptor.
              </li>
            </ul>
          </Text>
          <Title size={isDesktop ? 24 : 14} mt={!isDesktop && 10}>
            Forma de ejercicio
          </Title>
          <Text mt={isDesktop ? 15 : 8} pb={isDesktop ? 30 : 3} size={!isDesktop && 13} width="95%">
            Siempre que los valores estén custodiados por Inversiones Neurona,
            el pago se realizará a través de la plataforma.
          </Text>
        </Box>
      </Grid>
      {!isDesktop && <Line width="100%" />}
      <Grid
        item
        container
        justify="flex-end"
        xs={isDesktop ? 6 : 12}
        style={{
          marginTop: !isDesktop && '19px',
          marginBottom: !isDesktop && '17px',
        }}
      >
        <Grid container justify="space-evenly">
          {singleProject?.status === projectStateType.ADVERTISING_CAMPAIGN
            && !lessThanOneDay
            && (
              <HeaderItem
                isDesktop={isDesktop}
                description="Fecha de pre lanzamiento"
                icon={isDesktop ? CalendarIcon : CalendarIconGreen}
                title={`${toLocalDate(singleProject?.campaignDate)}`}
                mobileDescription={(
                  <>
                    Fecha de pre lanzamiento:
                    <br />
                    {toLocalDate(singleProject?.campaignDate)}
                  </>
                )}
              />
            )}
          {singleProject?.status === projectStateType.ADVERTISING_CAMPAIGN
            && lessThanOneDay
            && (
              <HeaderItem
                title={formattedTime || '00:00:00'}
                isDesktop={isDesktop}
                iconWidth={isDesktop && '34px'}
                icon={isDesktop ? ClockIcon : ClockIconGreen}
                description="Invierte en"
                mobileDescription={(
                  <>
                    {'Invierte en: '}
                    {formattedTime || '00:00:00'}
                  </>
                )}
              />
            )}
          {(singleProject?.status === projectStateType.CLOSED
            || singleProject?.status === projectStateType.PENDING_PAYMENT)
            && (
              <HeaderItem
                isDesktop={isDesktop}
                description="Fecha de cierre"
                icon={isDesktop ? CalendarIcon : CalendarIconGreen}
                title={`${toLocalDate(singleProject?.closureDate)}`}
                mobileDescription={(
                  <>
                    Fecha de cierre:
                    <br />
                    {toLocalDate(singleProject?.closureDate)}
                  </>
                )}
              />
            )}
          {singleProject?.status === projectStateType.OPEN && (
            <HeaderItem
              isDesktop={isDesktop}
              iconWidth={isDesktop && '34px'}
              icon={isDesktop ? ClockIcon : ClockIconGreen}
              description={`queda${singleProject.daysLeft !== 1 ? 'n' : ''} para invertir`}
              title={`${singleProject?.daysLeft} ${singleProject.daysLeft === 1 ? 'día' : 'días'}`}
              mobileDescription={
                `Queda${singleProject.daysLeft !== 1 ? 'n' : ''} ${singleProject?.daysLeft} ${singleProject.daysLeft === 1 ? 'día' : 'días'} para invertir`
              }
            />
          )}
          {singleProject?.status === projectStateType.WAITING_LEGAL_REP_CONFIRMATION && (
            <HeaderItem
              isDesktop={isDesktop}
              iconWidth={isDesktop && '34px'}
              icon={isDesktop ? CalendarIcon : CalendarIconGreen}
              description="Fecha de lanzamiento"
              title={`${toLocalDate()}`}
              mobileDescription="Fecha de lanzamiento"
            />
          )}
          {(singleProject?.status === projectStateType.OPEN
            || singleProject?.status === projectStateType.CLOSED
            || singleProject?.status === projectStateType.COLLECTING
            || singleProject?.status === projectStateType.PENDING_COMMISSION
            || singleProject?.status === projectStateType.PENDING_PAYMENT)
            && (
              <HeaderItem
                isDesktop={isDesktop}
                description="inversionistas"
                iconWidth={isDesktop && '43px'}
                icon={isDesktop ? PersonIcon : PersonIconGreen}
                title={`${singleProject?.currentInvestorsAmount}`}
              />
            )}
        </Grid>
        <Grid
          container
          style={{
            paddingLeft: '9%',
            marginTop: '34px',
            background: colors.secondary,
            maxHeight: isDesktop && '90px',
            width: isDesktop ? '97%' : '100%',
            paddingTop: isDesktop ? '16px' : '14px',
            paddingBottom: isDesktop ? '16px' : '14px',
            borderRadius: isDesktop ? '34px 0px 0px 34px' : '30px',
          }}
          alignItems="center"
        >
          <Text
            mr={isDesktop ? 32 : 21}
            size={isDesktop ? 16 : 12}
            style={{ width: isDesktop ? 'fit-content' : '27.4%' }}
          >
            Comparte el proyecto:
          </Text>
          <NetworksShare
            direction="row"
            mr={!isDesktop && 0}
            url={window.location.href}
            itemMargin={!isDesktop && '0px'}
            title={singleProject?.companyName}
            width={isDesktop ? '36px' : '27px'}
            height={isDesktop ? '36px' : '27px'}
            description={singleProject?.shortDescription}
            iconProps={{ mr: isDesktop ? 36 : (isSmall ? 15 : 25) }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

const HeaderItem = ({
  icon, title, description, isDesktop, mobileDescription, iconWidth,
}) => (
  <Grid
    container
    alignItems="center"
    direction={isDesktop ? 'column' : 'row'}
    style={{
      width: isDesktop && 'fit-content',
      marginBottom: !isDesktop && '13px',
    }}
  >
    <Box
      alt=""
      src={icon}
      component="img"
      width={iconWidth || (isDesktop ? '30px' : '19px')}
    />
    {isDesktop
      ? (
        <>
          <Title style={{ marginTop: iconWidth ? `calc(48px - ${iconWidth})` : 18 }} size={24} isCenter>
            {title}
          </Title>
          <Text size={18} isCenter>
            {description}
          </Text>
        </>
      )
      : (
        <Text size={13} ml={12} width="fit-content" style={{ maxWidth: 'calc(100% - 31px)' }}>
          {mobileDescription || (
            <span>
              {title}
              {' '}
              {description}
            </span>
          )}
        </Text>
      )}
  </Grid>
);
